import React from 'react';
import {Icon} from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import "./HomeTopButtons.scss"
import * as R from "../../../common/routes";

const HomeTopButtons: React.FC = () => {
    const navigate = useNavigate();
    return (
        <div className='home-top-group'>
            <Icon circular link size='big' color='teal' className='home-top-button'
                name="info" onClick={() => navigate(R.ABOUT_DARTS)} />
            <Icon circular link size='big' color='teal' className='home-top-button'
                name="at" onClick={() => navigate(R.SEND_EMAIL)} />
            <Icon circular link size='big' color='teal' className='home-top-button'
                name="money" onClick={() => navigate(R.BILLING_PLANS)} />
        </div>
    );
};

export default HomeTopButtons;
